import { makeAutoObservable } from 'mobx'
import { handleError } from '../API'
import { createTheme, deleteTheme, getThemeDetail, getThemes, updateTheme } from '../API/theme'
import { ITheme } from '../interfaces/theme'
import { IFilter } from '../types/common'
import { countTheme } from './../API/theme/index'
import { RootStore } from './index'

class ThemeStore {
  rootStore: RootStore

  themes: ITheme[] = []
  themeLength: number = -1

  themeDetail: ITheme = {}

  selectedTheme: ITheme = {}
  newTheme: ITheme = {}

  loading: boolean = false
  isLightSideBar: boolean = false

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  async fetchThemeList(filter: IFilter<ITheme> = {}): Promise<void> {
    if (this.loading) return
    this.loading = true
    const filterWithDefault = {
      ...filter,
      where: {
        ...filter.where,
        organizationId: this.rootStore.authStore.activeOrgId ?? 0
      }
    }
    try {
      this.themes = await getThemes(filterWithDefault)
      this.themeLength = await countTheme(filterWithDefault?.where ?? {})
    } catch (error: any) {
      handleError(error as Error, 'stores/themeStore.ts', 'fetchThemeList')
    }
    this.loading = false
  }

  async createTheme(theme: ITheme): Promise<ITheme> {
    try {
      const newTheme: ITheme = await createTheme(theme)
      this.themeDetail = newTheme as ITheme
      return newTheme
    } catch (error: any) {
      handleError(error as Error, 'stores/themeStore.ts', 'createNewTheme')
      return {}
    }
  }

  async fetchThemeDetail(id: number, filter: IFilter<ITheme> = {}): Promise<void> {
    try {
      const theme: ITheme = await getThemeDetail(id, filter)
      this.themeDetail = theme
    } catch (error: any) {
      handleError(error as Error, 'stores/themeStore.ts', 'fetchThemeDetail')
    }
  }

  async editTheme(id: number, theme: ITheme): Promise<void> {
    try {
      await updateTheme(id, theme)
    } catch (error: any) {
      handleError(error as Error, 'stores/themeStore.ts', 'updateTheme')
    }
  }

  async removeTheme(id: number): Promise<void> {
    try {
      await deleteTheme(id)
      this.themes = this.themes.filter(theme => theme.id !== id)
    } catch (error: any) {
      handleError(error as Error, 'stores/themeStore.ts', 'removeTheme')
    }
  }

  setThemeDetail(theme: ITheme): void {
    this.themeDetail = theme
  }

  resetThemeDetail(): void {
    this.themeDetail = {}
  }

  selectTheme(theme: ITheme): void {
    this.selectedTheme = theme
  }

  setNewTheme(theme: ITheme): void {
    this.newTheme = theme
  }

  setLightSideBar(isLightSideBar: boolean): void {
    this.isLightSideBar = isLightSideBar
  }
}

export default ThemeStore
